import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";

// css
import "./vraRadAffinity.css"
// mui
import Tables from "components/table/table";
import leftarrow from "assets/images/arrow-right.png";
import vraRadAffinityAPI from "apis/panel/vraRadAffinity/vraRadAffinity"
import Context from "context/context";

import Box from '@mui/material/Box';


import EditIcon from '@mui/icons-material/Edit';
import Modal from '@mui/material/Modal';

import 'react-calendar/dist/Calendar.css';
import moment from 'moment';
import { Button } from "../../../../../node_modules/@mui/material/index";
import EditVraRadAffinity from "./EditVraRadAffinity";
import swal from 'sweetalert';


const style = {
  position: 'absolute',
  top: '60%',
  left: '60%',
  transform: 'translate(-60%, -60%)',
  width: "98%",
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: 24,
  p: 4,
  borderRadius: "10px",
  maxHeight: "90vh",
  overflowY: "scroll",
};

const VraRadAffinity = () => {
  const { state, dispatch } = useContext(Context);
  const [roleCode] = useState(state.role.roleCode);
  const navigate = useNavigate();

 const {getAllVraRadAffinityAPI} = vraRadAffinityAPI()
  
  const [vraRadAffinityDetails, setVraRadAffinityDetails] = useState([])
  const [offset, setOffset] = useState(1);
  const [count, setCount] = useState(0);
  const [searchValue, setSearchValue] = useState("");
  const [filterValue, setFilterValue] = useState("");
 
  const [editId,setEditId] = useState('')
  const [open, setOpen] = useState(false);
  
  const [serialNumber, setSerialNumber] = useState("");


const handleEdit = async(id)=>{
  swal({
    title: "Are you sure?",
    text: "The data in Affinity table is auto-generated. Editing this data might create issues. You will be responsible for any changes made.",
    icon: "warning",
    buttons: {
      cancel: {
        text: "Reject",
        value: false,
        visible: true,
        className: "swal-button-disagree", 
      },
      confirm: {
        text: "Accept",
        value: true,
        visible: true,
        className: "swal-button-agree", 
      },
    },
    dangerMode: true,
  })
  .then((willNavigate) => {
    if (willNavigate) {
      setOpen(true)
    
      setEditId(id)
    } else {
       
       return
      
    }
  });
 
 
}

const handleNavigate = () => {
  swal({
    title: "Are you sure?",
    text: "The data in Affinity table is auto-generated. Adding data might create issues. You will be responsible for any changes made.",
    icon: "warning",
    buttons: {
      cancel: {
        text: "Reject",
        value: false,
        visible: true,
        className: "swal-button-disagree", 
      },
      confirm: {
        text: "Accept",
        value: true,
        visible: true,
        className: "swal-button-agree", 
      },
    },
    dangerMode: true,
  })
  .then((willNavigate) => {
    if (willNavigate) {
      navigate("/panel/addVraRadAffinity");
    } else {
       
       return
      
    }
 
})
}

const handleNavigation=()=>{
  navigate("/panel/rpHomePage")
}


const handleClose= async()=>{
  setEditId('')
  setOpen(false)
}

  const handleGetAllVraRadAffinityDetailsApi = async () => {
    try {
      dispatch({ type: "SET_LOADING", payload: true });
      let values;
      values = {
        offset: (offset - 1) * 20,
        limit: 20,
      };
      if (searchValue) {
        values = {
            ...values,
          searchValue,
        };
      }
      if (filterValue) {
        values = {
            ...values,
          filterValue,
        };
      }
      let res = await getAllVraRadAffinityAPI(values);
      setVraRadAffinityDetails(res?.data?.vraRadAffinity || []);
      setCount(res?.data?.count);
      setSerialNumber(offset)
      dispatch({ type: "SET_LOADING", payload: false });
    } catch (err) {
      dispatch({ type: "SET_LOADING", payload: false });
    }
  };


  useEffect(() => {
    handleGetAllVraRadAffinityDetailsApi()
  }, [offset, searchValue, filterValue,open])

  return (
    <div
      className="vraShiftsMediaQuery"
      style={{
        backgroundColor: "white",
        borderRadius: "10px",
      }}
    >
      <Tables
       title={
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div onClick={handleNavigation} style={{ cursor: 'pointer', paddingRight: 8 }}>
            <img src={leftarrow} alt="Back" />
          </div>
          <Box sx={{ pt: 2, pb: 2 }} className="VraShiftsTitle">
          VRA RAD Affinity Roster
          </Box>
        </div>
      }
        searchBar={true}
        filter={false}
        role={roleCode}
        create={
         
           <Button className="AddEmployerButton" onClick={handleNavigate}>
              Add Affinity
           </Button>
         }
        setSearchValue={setSearchValue}
        filterValue={filterValue}
        setFilterValue={setFilterValue}
        filterValues={[
          { label: "Affinity Start Date", value: "" },
          { label: "Shifts Together", value: "number_of_shifts_together" },
        ]}
        heading={[
          "S.No",
          "Affinity Start Date",
          "Number Of Shifts Together",
          "VRA SRF Name",
          "VRA Full Name",
          "RAD Qgenda Full Name",
          "Actions"      
        ]}
        data={vraRadAffinityDetails?.map((e, index) => [
              index + 1 + (serialNumber - 1) * 20,   
              e.affinitystartdate? moment(e.affinitystartdate).format('DD-MMM-YYYY') : e.affinitystartdate,
              e.numberofshiftstogether,
              e.srfname,
              e.vrafullname,      
              e.radqgendafullname,
              <EditIcon style={{color:"#FE6024",cursor: 'pointer'}}  onClick={() => handleEdit(e.affinityid)}/>,
         ])}
         offset={offset}
         limit={20}
         setOffset={setOffset}
         count={count}
         placeholder="Search by  VRA SRF Name, VRA Full Name"
         />

    <Modal open={open}  onClose={handleClose} aria-labelledby="modal-title"
                aria-describedby="modal-description" >
<Box sx={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  height:300,
                  transform: 'translate(-50%, -50%)',
                  width: 600, 
                  bgcolor: 'background.paper',
                  borderRadius:'10px',
                  p: 4,}} >
         <EditVraRadAffinity id={editId} onClose={handleClose} />
        </Box>
      </Modal>
     
    </div>
  )
}


export default VraRadAffinity